'use client'

export default function PlaceholderAscii() {
  return (
    <div className="w-full h-full min-h-[400px] relative flex items-center justify-center">
      <div 
        className="absolute inset-0 bg-gradient-to-br from-blue-500/10 to-green-500/10 
                   flex items-center justify-center"
        aria-hidden="true"
      >
        <pre className="text-green-400 font-mono text-xs md:text-sm lg:text-base opacity-80 select-none scale-75 sm:scale-100">
{`
 _    __                        _ __ 
| |__/ /__ ___ ____ ____ _ ___ (_) / 
| / _  / _ \` _ \`/ _ \`/  ' \\ __// / /
|/ /_/ / /_/  ' /\\_,_/_/_/_/ / /_/  
|__/                      |___/      

  << Loading Matrix in T-minus 3... >>

      ⚡ 01100011 01101111 01100100 01100101 ⚡
       
  |_  _ |_)|_ _ _  |_  _ |_  _ _ _ |  _ 
  | |(_|| \\|_(_(_) | |(_||_)(_| (_||_|_)
                                    |    
`}
        </pre>
        
        <div className="absolute bottom-4 left-4 flex space-x-2">
          <div className="w-3 h-3 rounded-full bg-green-500"></div>
          <div className="w-3 h-3 rounded-full bg-yellow-500"></div>
          <div className="w-3 h-3 rounded-full bg-red-500"></div>
        </div>
        
        <div className="absolute bottom-4 right-4 text-xs text-green-400 flex items-center">
          <span className="animate-pulse mr-1">▊</span>
          <span>Brewing coffee to feed the 3D engine...</span>
        </div>
      </div>
    </div>
  )
} 